import * as ngCore from '@angular/core'
import * as ngMatDatepicker from '@angular/material/datepicker'

import * as config from '../../../config'

/** Datepicker input using the shared date-only display configuration. */
@ngCore.Component({
  imports: [ngMatDatepicker.MatDatepickerModule],
  providers: [...config.dateFormat.DATE_MATERIAL_PROVIDERS],
  selector: 'atn-ds-datepicker',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Name displayed above datepicker  */
  public readonly labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /** Date value */
  public readonly valueSg = ngCore.model<Date | undefined>(undefined, {
    alias: 'value',
  })

  /** Whether the datepicker is disabled */
  public readonly disabledSg = ngCore.input(false, { alias: 'disabled' })

  /** Propagates Angular Material date changes through the component model. */
  public onDateChangeHandler({
    value,
  }: ngMatDatepicker.MatDatepickerInputEvent<Date>): void {
    // TODO: do we need to handle internationalization?
    this.valueSg.set(value ?? undefined)
  }
}
